import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { ModalHeader, ModalBody } from 'reactstrap'
import { isEmpty } from 'lodash'

import UIActions from 'store/redux/ui'
import { Modal, SelectorButton, Text, PreSeasonPerformanceLine, SvgGrid } from 'components'
import PHASE, { isAfter } from 'utils/constants/phases'
import './CurrentSelectionModal.css'

const svgViewBox = '0 0 215 110'
const viewBox = { x: 28.3, y: 0.5, width: 186.2, height: 97.1 }

@connect(
    state => ({
        isOpen: state.ui.isCurrentSelectionModalOpen,
        phase: state.phaseInfo.phase,
        currentSelection: state.phaseInfo.currentSelection,
        curvesParams: state.phaseInfo.performanceOverDeteriorationCurveParams
    }),
    {
        toggle: UIActions.toggleCurrentSelectionModal
    }
)
@translate()
export class CurrentSelectionModal extends PureComponent {
    renderColumn = (data, type) => {
        const { t, curvesParams } = this.props

        return (
            <div className="Column flex col-stretch">
                <SelectorButton icon={data.icon} id={data.name} label={data.name} />
                <div>
                    <div className="Column__Description pt-2">{data.description}</div>
                    <div className="Column__Units">
                        <div className="Column__Units--selected">
                            <span className="Column__Units--selected-number">{data.unitsUsed} </span>
                            <span dangerouslySetInnerHTML={{ __html: t('modal.currentSelection.unitsUsed') }} />
                        </div>
                        <div className="Column__Units--left">
                            <span>{data.unitsLeft} </span>
                            <span dangerouslySetInnerHTML={{ __html: t('modal.currentSelection.unitsLeft') }} />
                        </div>
                    </div>
                </div>

                <div className="CurrentSelectionModal__Chart pt-5">
                    <Text className="ChartLegend Y">{t('game.POST_RACE.panelLineChartYLabel')}</Text>
                    <svg viewBox={svgViewBox} className="WhiteBg">
                        <SvgGrid viewBox={viewBox} zeroLabel="0%" xLabel="100%" yLabel="100%" clipId="viewBoxClip-currentSelection" />
                        <PreSeasonPerformanceLine curvesParams={curvesParams} typeSelected={type} outputViewBox={viewBox} clipPath="url(#viewBoxClip-currentSelection)" />
                    </svg>
                    <Text className="ChartLegend X">{t('game.POST_RACE.panelLineChartXLabel')}</Text>
                </div>
            </div>
        )
    }
    render() {
        const { isOpen, phase, currentSelection, toggle, t } = this.props

        return (
            phase &&
            isAfter(phase, PHASE.PRE_SEASON) && (
                <Modal isOpen={isOpen} onDismiss={toggle} className="CurrentSelectionModal">
                    <ModalHeader toggle={toggle} />
                    <h1 dangerouslySetInnerHTML={{ __html: t('modal.currentSelection.title') }} />
                    <ModalBody>
                        {!isEmpty(currentSelection) ? (
                            <div className="flex row-stretch-top">
                                {this.renderColumn(currentSelection.engine, 'engine')}
                                {this.renderColumn(currentSelection.gearbox, 'gearbox')}
                                {this.renderColumn(currentSelection.wheels, 'wheels')}
                            </div>
                        ) : (
                                <p>{t('error.noItemsSelected')}</p>
                            )}
                    </ModalBody>
                </Modal>
            )
        )
    }
}



// WEBPACK FOOTER //
// src/components/StatusBar/CurrentSelectionModal/CurrentSelectionModal.js